<template>
    <div class="card section" ref="section">

        <div class="section__actions">
            <ul>
                <li v-on:mousedown="collapseForMoving"><i class="fas fa-arrows-alt-v"></i></li>
                <li v-on:click="editSection"><i class="fas fa-edit"></i></li>
                <li v-on:click="deleteSection"><i class="fas fa-trash-alt"></i></li>
            </ul>
        </div>

        <div>
            <a href="#">
                <div v-on:click="addSection(false)" class="section__add section__add--top">+</div>
            </a>
        </div>
        <div>
            <a href="#">
                <div v-on:click="addSection(true)"  class="section__add section__add--bottom">+</div>
            </a>
        </div>

        <div v-if="deleting || error" class="infobar" v-bind:class="{'infobar-info' : deleting, 'infobar-error' : error}">
            {{infoMessage}}
        </div>

        <template v-show="!deleted">
            <div class="card-header">
                <div class="section__header">
                    <div class="section__header--left media">
                        <i v-bind:class="getSectionIcon" aria-hidden="true"></i>
                        <div class="media-body">
                            <h5 class="card-title">{{section.title}}</h5><br/>
                            <h6 v-if="isPerPerson" class="card-title text-muted">Note: This section will be repeated for
                                each guest in each {{getUnitTypeForDisplay}}. You can vary the questions asked of different
                                guests (e.g. ask first guest for contact details but don’t ask others)</h6>
                            <h6 v-if="isPerRoom" class="card-title text-muted">Note: This section will be repeated for
                                each {{getUnitTypeForDisplay}}</h6>
                        </div>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <div class="card-body" v-show="!movingSection" ref="listOfQuestions" v-bind:class="{'section__body--after-intro' : section.introduction}">
                    <div class="section__intro" v-if="section.introduction" v-bind:inner-html.prop="section.introduction | marked"></div>
                    <div v-if="section.questions.length === 0" class="question question__placeholder">
                        <div>
                            <a href="#">
                                <div v-on:click="addQuestion(section.reference, 0)" class="question__add section__add--top">+</div>
                            </a>
                        </div>
                        <div>
                            <a href="#">
                                <div v-on:click="addQuestion(section.reference, 0)" class="question__add section__add--bottom">+</div>
                            </a>
                        </div>
                        Click / tap to add a question
                    </div>
                    <Draggable v-model="section.questions" group="questions" @start="movingQuestion=true" @change="movedQuestion" @end="movingQuestion=false" v-bind:disabled="disableDragging">
                        <FormQuestionTemplate v-for="(question, index) in section.questions"
                                              v-bind:formTemplateReference="formTemplateReference"
                                              v-bind:formSectionReference="section.reference"
                                              v-bind:askingPersonalInformation="section.type == 'personal-information'"
                                              v-bind:question="question"
                                              v-bind:key="question.reference"
                                              v-bind:index="index"/>
                    </Draggable>
                </div>
            </transition>

            <div v-if="editing">
                <EditSection v-bind:formTemplateReference="formTemplateReference" v-bind:section="this.section" v-bind:index="index" v-if="editing"></EditSection>
            </div>
        </template>
    </div>
</template>

<script>
    import { store, getters } from '../../store.js'
    import Draggable from 'vuedraggable'
    import FormQuestionTemplate from './FormQuestionTemplate'
    import EditSection from './EditSection'

    export default {
        name: 'FormSection',
        components: {
            Draggable, FormQuestionTemplate, EditSection
        },
        props: {
            formTemplateReference: String,
            section: Object,
            index: Number,
            movingSection: Boolean,
        },
        data: function () {
            return {
                editing: false,
                deleting: false,
                deleted: false,
                error: false,
                infoMessage: "Deleting section",
                movingQuestion: false,
                disableDragging: false
            }
        },
        computed: {
            getSectionIcon: function () {
                switch (String(this.section.type)) {
                    case 'stay-information':
                        return 'fas fa-concierge-bell'
                    case 'room-information':
                        return 'fas fa-bed'
                    case 'personal-information':
                        return 'fa fa-male'
                    case 'terms-and-conditions':
                        return 'fas fa-file-contract'
                    case 'general':
                    default:
                        return 'fas fa-list'
                }
            },
            isPerPerson: function () {
                return this.section.type === "personal-information";
            },
            isPerRoom: function () {
                return this.section.type === "room-information";
            },
            getUnitTypeForDisplay: function() {
                return getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
            }
        },
        methods: {
            scrollToTopOfSection: function () {
                const rect = this.$el.getBoundingClientRect()
                window.scrollTo(rect.x, window.pageYOffset + rect.top - 5)
            },
            collapseForMoving: function() {
                // this is hear because view reactivity isn't fast enough to collapse the questions before dragging
                this.$refs.listOfQuestions.style.display = 'none';
                this.$refs.section.style.border = 'none';
                this.$root.$emit('moving-section');
            },
            addNewSection: function(formTemplateReference, index) {
                if (this.formTemplateReference === formTemplateReference && this.index === index) {
                    console.log("Opening dialog to edit new section");
                    this.editing = true;
                    this.$root.$emit('editing-section-or-question');
                    this.scrollToTopOfSection();
                }
            },
            editSection: function() {
                console.log('edit');
                this.editing = true;
                this.disableDragging = true;
                this.$root.$emit('editing-section-or-question');
                console.log('showing edit modal');
            },
            deleteSection: function() {
                console.log("Deleting section");
                this.deleting = true;
                this.infoMessage = "Deleting question";
                this.$http.delete('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                    + '/form-templates/' + this.formTemplateReference
                    + "/section-templates/" + this.section.reference
                ).then(response => {
                    console.log("Section deleted:")
                    console.log(response);
                    this.infoMessage = "Section successfully deleted";
                    this.deleted = true;
                    setTimeout(() => {
                        this.deleting = false;
                        this.$root.$emit('delete-section-from-form', this.formTemplateReference, this.index);
                    }, 2000);
                }).catch(error => {
                    this.deleting = false;
                    this.error = true;
                    if (error.response) {
                        this.infoMessage = "Error: " + error.response.data.message
                    } else {
                        this.infoMessage = "Error deleting section";
                    }
                    setTimeout(() => {
                        this.error = false;
                    }, 5000);
                });
            },
            addSection: function(after) {
                console.log("Adding section");
                let addIndex = this.index;
                if (after) {
                    addIndex = addIndex + 1;
                }
                this.$root.$emit('add-section-to-form', this.formTemplateReference, addIndex);
            },
            addQuestion: function(sectionReference, index) {
                if (this.section.reference === sectionReference) {
                    console.log("adding question to this section at index: " + index);
                    this.section.questions.splice(index, 0, { question: "", note: "", type: "short-answer", askQuestion: "all-guests", required: false, copyable: false, options: [], validationMessage: ""});
                    setTimeout(() => {
                        this.$root.$emit('edit-new-question', sectionReference, index);
                    }, 500);
                }
            },
            movedQuestion: function(event) {
                console.log("Moved: " + this.section.reference + "::");
                console.log(event);
                let body = {};
                if (event.moved) {
                    body = {
                        reference: event.moved.element.reference,
                        index: event.moved.newIndex
                    };
                    console.log("Change ordering...");
                } else if (event.added) {
                    body = {
                        reference: event.added.element.reference,
                        index: event.added.newIndex
                    };
                    console.log("Change parent...");
                }
                if (event.moved || event.added) {
                    this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                        + '/form-templates/' + this.formTemplateReference + "/section-templates/" + this.section.reference + "/move-question", body
                    ).then(response => {
                        console.log("Question moved. Response: ");
                        console.log(response)
                    }).catch(error => {
                        if (error.response) {
                            this.error = error.response.data.message
                        } else {
                            this.error = "Sorry, we can't seem to reach our servers! Please try again"
                        }
                    });
                    console.log("Moved question...");
                }
            },
            copyQuestionFromTemplate: function(sectionReference, index, template) {
                if (this.section.reference === sectionReference) {
                    console.log("copying question from template");
                    Object.assign(this.section.questions[index], template);
                    delete this.section.questions[index].reference;
                }
            },
            deleteQuestion: function(sectionReference, index) {
                if (this.section.reference === sectionReference) {
                    this.section.questions.splice(index, 1);
                }
            },
            editingSectionOrQuestion: function() {
                this.disableDragging = true;
            },
            stopEditingSectionOrQuestion: function() {
                this.editing = false;
                this.disableDragging = false;
            },
        },
        mounted() {
            this.$root.$on('edit-new-section', this.addNewSection);
            this.$root.$on('editing-section-or-question', this.editingSectionOrQuestion);
            this.$root.$on('finished-editing-section-or-question', this.stopEditingSectionOrQuestion);
            this.$root.$on('add-question-to-section', this.addQuestion);
            this.$root.$on('delete-question-from-section', this.deleteQuestion);
            this.$root.$on('copy-template-info-question', this.copyQuestionFromTemplate);
        },
        beforeDestroy() {
            this.$root.$off('edit-new-section', this.addNewSection);
            this.$root.$off('editing-section-or-question', this.editingSectionOrQuestion);
            this.$root.$off('finished-editing-section-or-question', this.stopEditingSectionOrQuestion);
            this.$root.$off('add-question-to-section', this.addQuestion);
            this.$root.$off('delete-question-from-section', this.deleteQuestion);
            this.$root.$off('copy-template-info-question', this.copyQuestionFromTemplate);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/pages/view-form";
    @import "../../styles/pages/edit-form";
    @import "../../styles/components/question_answer";

    .infobar-info {
        margin-left: 10px;
        margin-right: 10px;
    }
</style>
